import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.error('Error getting auth token:', error);
  }
  return config;
});

export const judgingService = {
  // Get stories for judging in an event
  getEventStoriesForJudging: async (eventId) => {
    try {
      const response = await api.get(`/judging/events/${eventId}/stories`);
      return response.data;
    } catch (error) {
      console.error('Error getting event stories for judging:', error);
      throw error;
    }
  },

  // Submit or update judging comment
  submitJudgingComment: async (eventId, storyId, commentData) => {
    try {
      const response = await api.post(`/judging/events/${eventId}/stories/${storyId}`, commentData);
      return response.data;
    } catch (error) {
      console.error('Error submitting judging comment:', error);
      throw error;
    }
  },

  // Get judging comment by ID
  getJudgingComment: async (commentId) => {
    try {
      const response = await api.get(`/judging/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting judging comment:', error);
      throw error;
    }
  },

  // Delete judging comment
  deleteJudgingComment: async (commentId) => {
    try {
      const response = await api.delete(`/judging/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting judging comment:', error);
      throw error;
    }
  },

  // Get all judging comments for a story (admin only)
  getStoryJudgingComments: async (eventId, storyId) => {
    try {
      const response = await api.get(`/judging/events/${eventId}/stories/${storyId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting story judging comments:', error);
      throw error;
    }
  },

  // Get judging summary for an event (admin only)
  getEventJudgingSummary: async (eventId) => {
    try {
      const response = await api.get(`/judging/events/${eventId}/summary`);
      return response.data;
    } catch (error) {
      console.error('Error getting event judging summary:', error);
      throw error;
    }
  },

  // Get judging comments for author's own story
  getJudgingCommentsForMyStory: async (storyId) => {
    try {
      const response = await api.get(`/stories/${storyId}/judging-comments`);
      return response.data;
    } catch (error) {
      console.error('Error getting judging comments for story:', error);
      throw error;
    }
  }
};

export default judgingService;
